export type HeaderActionOptions = "sortAsc" | "sortDesc";
export const EMPTY_VALUE_PLACEHOLDER = "--";
